import { z } from 'zod'

import { useTranslation } from '@flecto/translations'
import { type CoreUserAddress } from '@flecto/types'

import { RangeEmitterDataBuilder } from '../components/AddressForm/AddressBusinessHours/HoursValidation'

type UseAddressSchemaOptions = {
  address?: Partial<CoreUserAddress>
}

export function useAddressSchema(options?: UseAddressSchemaOptions) {
  const { t } = useTranslation('shared', { keyPrefix: 'validation' })

  const schema = z.object({
    label: z.string().min(2, { message: t('required') }),
    address_city: z.string().min(2, { message: t('required') }),
    address_country_code: z.string().min(2, { message: t('required') }),
    address_postal_code: z.string().min(2, { message: t('required') }),
    address_street: z.string().min(2, { message: t('required') }),
  })

  const initialValues: Partial<CoreUserAddress> = {
    ...options?.address,
    open_to_public: options?.address?.open_to_public ?? false,
    operating_hours_type:
      options?.address?.operating_hours_type ?? 'always_open',
    operating_hours_schedule:
      options?.address?.operating_hours_schedule ??
      new RangeEmitterDataBuilder().data,
  }

  return { schema, initialValues }
}
